/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import SideBarEditForm from "../../../shared/forms/SideBarEditForm";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormTextBox from "../../../shared/forms/FormFields/FormTextBox";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import useApiDieselTanque from "../../../api/taller/useApiDieselTanque";
import FormCalendar from "../../../shared/forms/FormFields/FormCalendar";
import FormInputNumber from "../../../shared/forms/FormFields/FormInputNumber";
import moment from "moment";
import { tiposProveedor } from "../DieselConstantes";
import useSeguridad, { opcionesSeguridad } from "../../../Seguridad/useSeguridad";

import FormTabView from "../../../shared/forms/Tabs/FormTabView";
import ExGrid from "../../../shared/Grid/ExGrid";
import ExColumn from "../../../shared/Grid/ExColumn";
import { fechaUtc } from "../../../shared/Grid/GridCellRenderers";

const GeneralCargaTanque = ({
    value,
    onChange,
    onValidate,
    cargaId,
    tanques,
    ubicaciones,
    seguridad
}) => {
    const esEdicion = cargaId > 0;

    return (
        <Form
            columns={2}
            values={value ?? {}}
            onChange={onChange}
            onValidate={onValidate}
        >
            <Field
                field={"fechaRegistro"}
                label={"Fecha"}
                required={true}
                render={FormCalendar}
                disabled={!seguridad.tieneAcceso(opcionesSeguridad.editarTanque) && esEdicion}
            />

            <Field
                field={"ordenCompra"}
                label={"Orden de Compra"}
                required={true}
                render={FormTextBox}
                disabled={!seguridad.tieneAcceso(opcionesSeguridad.editarTanque) && esEdicion}
            />

            <Field
                field={"litros"}
                label={"Litros"}
                required={true}
                mode="decimal"
                maxFractionDigits={2}
                render={FormInputNumber}
                disabled={esEdicion}
            />

            <Field
                field={"precio"}
                label={"Precio"}
                required={true}
                mode="decimal"
                maxFractionDigits={2}
                render={FormInputNumber}
                disabled={esEdicion}
            />

            {
                tanques?.length > 1 &&
                <Field
                    field={"tanqueId"}
                    label={"Ubicación"}
                    required={true}
                    options={ubicaciones}
                    render={FormDropDown}
                    disabled={esEdicion}
                />
            }

            <Field
                field={"proveedorId"}
                label={"Proveedor"}
                source="diesel/proveedores"
                params={{ tipoProveedorId: tiposProveedor.pipas }}
                required={true}
                render={FormDropDown}
                disabled={esEdicion}
            />
        </Form>
    );
};

const HistorialCargaTanque = ({ value }) => {
    return (
        <ExGrid data={value ?? []}>
            <ExColumn title="Acción" field="accion" />
            <ExColumn title="Usuario" field="auditUser" />
            <ExColumn title="Fecha" field="fechaUtc" cellRenderer={fechaUtc} />
            <ExColumn title="Comentario" field="comentario" />
        </ExGrid>
    );
};

const CargaDetalle = ({ combustibleId, cargaId, onSaved, onCancel, tanques }) => {
    const api = useApiDieselTanque();
    const seguridad = useSeguridad();

    const esEdicion = cargaId > 0;
    const tanqueId = tanques.length > 1 ? null : tanques[0]?.id;

    const ubicaciones = tanques.map(e => {
        return {
            id: e.id,
            nombre: e.ubicacion.nombre
        };
    });

    const obtenerCarga = async (id) => {
        const result = await api.obtenerCarga(id);

        return {
            carga: {
                ...result,
                tanqueCargaId: result?.tanqueCargaId ?? result?.id ?? id,
                fechaRegistro: result?.fechaRegistro
                    ? moment(result.fechaRegistro).toDate()
                    : moment().startOf('day')._d
            },
            historial: result?.historial ?? []
        };
    };

    const guardar = async (entity) => {
        const carga = entity?.carga ?? entity;

        if (esEdicion) {
            const payload = {
                tanqueCargaId: carga.tanqueCargaId ?? cargaId,
                tanqueId: carga.tanqueId,
                ordenCompra: carga.ordenCompra,
                fechaRegistro: carga.fechaRegistro
            };

            console.log("Payload actualizar carga tanque:", payload);

            return api.cargasUpdate(payload);
        }

        const payload = {
            combustibleId,
            tanqueId: carga.tanqueId,
            ordenCompra: carga.ordenCompra,
            litros: carga.litros,
            precio: carga.precio,
            proveedorId: carga.proveedorId,
            fechaRegistro: carga.fechaRegistro
        };

        console.log("Payload guardar carga tanque:", payload);

        return api.guardarCarga(payload);
    };

    return (
        <>
            <SideBarEditForm
                id={cargaId}
                initialValues={{
                    carga: {
                        enabled: true,
                        fechaRegistro: moment().startOf('day')._d,
                        combustibleId,
                        tanqueId,
                        tanqueCargaId: cargaId ?? 0
                    },
                    historial: []
                }}
                getByIdFunction={obtenerCarga}
                saveFunction={guardar}
                onSaved={onSaved}
                onCancel={onCancel}
                showCancelButton={true}
            >
                <Form columns={1}>
                    <FormTabView>
                        <Field
                            title={esEdicion ? "Editar Carga" : "Agregar Carga"}
                            field="carga"
                            render={(props) => (
                                <GeneralCargaTanque
                                    {...props}
                                    cargaId={cargaId}
                                    tanques={tanques}
                                    ubicaciones={ubicaciones}
                                    seguridad={seguridad}
                                />
                            )}
                        />

                        {
                            esEdicion &&
                            <Field
                                title="Historial"
                                field="historial"
                                render={(props) => (
                                    <HistorialCargaTanque {...props} />
                                )}
                            />
                        }
                    </FormTabView>
                </Form>
            </SideBarEditForm>
        </>
    )
}

export default CargaDetalle;